// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../../types';
import { BOLD } from '../../../../../../helpers/fontWeight';
import Price from '../../../../../price';

export const PriceWrapper = styled<any, Theme>('section')`
  display: flex;
  justify-content: space-between;
`;

export const StyledPrice = styled<typeof Price, Theme>(Price)`
  color: ${props => props.theme.cart.titleColor};
  font-size: 1.75rem;
  font-weight: ${BOLD};
`;

export default null;
